// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"701c5374","255":"701c5374"}[chunkId] + ".chunk.css";
};